/* ==========================================================================
   RAIKI - Secuencia de entrada de la portada
   ADR wow-02 · Sprint 01 · revisado 26-ago

   QUE HACE LA REFERENCIA, medido:
     - la figura NO se mueve en reposo: entra, llega y se queda quieta
     - una línea del titular va DETRAS de la figura y otra DELANTE
   Ese sandwich de capas es lo que da profundidad. Lo resuelve el CSS.

   DIRECCION PROPIA DE RAIKI (decisión del cliente, no copia):
     - un rayo barre la pantalla de izquierda a derecha
     - las letras se revelan DETRAS del rayo, como si el rayo las encendiera
     - destello en el impacto
     - la corredora cruza de izquierda a derecha y FRENA en su sitio
   Es literalmente el "descarga eléctrica" del vibe statement, y encadena:
   cada cosa parece consecuencia de la anterior, no una lista de efectos.

   REGLA CENTRAL: animamos "from", nunca "to". Si el motor no carga, queda
   todo en su sitio y legible.
   ========================================================================== */

(function () {
  'use strict';

  // Recorte de izquierda a derecha. Los -25% arriba y abajo son para que el
  // contorno de las letras y el brillo no queden cortados por el recorte.
  var OCULTO = 'inset(-25% 100% -25% 0%)';
  var VISIBLE = 'inset(-25% 0% -25% 0%)';

  function iniciar() {
    if (typeof window.gsap === 'undefined') return;

    var portada = document.querySelector('.raiki-hero[data-motion="on"]');
    if (!portada) return;
    if (portada.dataset.animado === 'true') return;
    portada.dataset.animado = 'true';

    // La clase apaga la animación CSS de reserva y deja todo visible; desde
    // acá manda GSAP.
    portada.classList.add('raiki-hero--js');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var raiz = getComputedStyle(document.documentElement);
    var dur = parseFloat(raiz.getPropertyValue('--raiki-hero-dur')) || 1.4;
    var pausa = parseFloat(raiz.getPropertyValue('--raiki-hero-pausa')) || 0.3;

    var q = function (s) { return portada.querySelector(s); };
    var eyebrow = q('.raiki-hero__eyebrow');
    var linea1 = q('.raiki-hero__linea--1');
    var linea2 = q('.raiki-hero__linea--2');
    var cta = q('.raiki-hero__cta');
    var senal = q('.raiki-hero__senal');
    var figura = q('.raiki-hero__figura');
    var rayo = q('.raiki-hero__rayo');
    var destello = q('.raiki-hero__destello');

    var tl = gsap.timeline({
      delay: pausa,
      onComplete: function () {
        // Dejamos las letras sin recorte al terminar: si la pestaña cambia de
        // tamaño después, un inset viejo podría comerse una letra.
        [linea1, linea2].forEach(function (el) {
          if (el) el.style.clipPath = '';
        });
      }
    });

    // 1. EL RAYO cruza la pantalla, rápido y recto.
    if (rayo) {
      tl.set(rayo, { opacity: 1 }, 0)
        .fromTo(rayo,
          { xPercent: -140 },
          { xPercent: 340, duration: 0.55, ease: 'power2.in' }, 0)
        .to(rayo, { opacity: 0, duration: 0.2 }, 0.44);
    }

    // 2. LAS LETRAS se encienden detrás del rayo, en el mismo sentido.
    //    No entran "solas": las enciende el rayo al pasar. Ese encadenado es
    //    la diferencia entre una lista de efectos y una secuencia.
    if (linea1) {
      tl.fromTo(linea1,
        { clipPath: OCULTO, webkitClipPath: OCULTO },
        { clipPath: VISIBLE, webkitClipPath: VISIBLE, duration: 0.5, ease: 'power2.out' }, 0.14);
    }
    if (linea2) {
      tl.fromTo(linea2,
        { clipPath: OCULTO, webkitClipPath: OCULTO },
        { clipPath: VISIBLE, webkitClipPath: VISIBLE, duration: 0.45, ease: 'power2.out' }, 0.3);
    }

    // 3. DESTELLO en el impacto: dos cuadros de luz y se apaga.
    if (destello) {
      tl.to(destello, { opacity: 0.32, duration: 0.05, ease: 'none' }, 0.46)
        .to(destello, { opacity: 0, duration: 0.3, ease: 'power2.out' }, 0.51);
    }

    // 4. LA CORREDORA sigue al rayo, de izquierda a derecha, y FRENA.
    //    Nada de rebote: llega con inercia y se detiene. Una corredora que
    //    rebota al llegar se ve cómica, no atlética.
    //
    //    ENTRA CON PRESENCIA PLENA Y DESPUÉS SE ASIENTA. En teléfono la figura
    //    vive a media opacidad para que el titular mande, y con eso su entrada
    //    no se percibía: no se ve moverse algo que casi no se ve. Entra opaca,
    //    que es cuando el movimiento tiene que leerse, y baja al valor de
    //    reposo recién cuando ya llegó, que es cuando el texto necesita ganar.
    //
    //    El valor de reposo se lee del token --figura-opacidad en vez de
    //    escribirlo acá, para no tener el mismo número en dos archivos. En
    //    escritorio ese token es 1, el pico también, y todo esto es un no-op:
    //    la entrada queda exactamente como estaba.
    if (figura) {
      var reposo = parseFloat(getComputedStyle(figura).getPropertyValue('--figura-opacidad'));
      if (isNaN(reposo)) reposo = 1;
      var pico = Math.min(1, reposo + 0.4);

      tl.fromTo(figura,
        { xPercent: -240, opacity: 0 },
        { xPercent: 0, opacity: pico, duration: dur * 1.2, ease: 'power3.out' }, 0.34);

      if (pico > reposo) {
        tl.to(figura, { opacity: reposo, duration: dur * 0.75, ease: 'power2.inOut' }, '>-0.1');
      }
    }

    // 5. Los apoyos entran después, sin robar protagonismo.
    if (eyebrow) {
      tl.from(eyebrow, { yPercent: -60, opacity: 0, duration: dur * 0.55, ease: 'power3.out' }, 0.2);
    }
    if (cta) {
      tl.from(cta, { yPercent: 70, opacity: 0, duration: dur * 0.5, ease: 'back.out(1.8)' }, 0.9);
    }
    if (senal) {
      tl.from(senal, { opacity: 0, duration: dur * 0.5, ease: 'power2.out' }, 1.1);
    }

    /* Ya se puede destapar. Los from y fromTo de GSAP escriben el estado
       inicial en el momento de crearse (immediateRender), asi que a esta
       altura los estilos en linea ya estan puestos y quitar la clase no
       produce ningun parpadeo: solo deja de hacer falta.                  */
    portada.classList.remove('raiki-hero--preparado');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  // El editor de temas vuelve a montar la sección al cambiar un ajuste.
  document.addEventListener('shopify:section:load', function (e) {
    var p = e.target && e.target.querySelector('.raiki-hero');
    if (p) {
      p.dataset.animado = 'false';
      iniciar();
    }
  });
})();
